module.exports = __webpack_public_path__ + "fonts/PangMenZhengDaoBiaoTiTi-1的副本.e6033c0b.ttf";